import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop, disableScrollRestoration, handleHashNavigation } from '@/lib/scrollUtils';

/**
 * ScrollToTop Component
 * 
 * Ensures consistent scroll behavior across the application:
 * 1. Scrolls to top on every route change
 * 2. Disables browser's automatic scroll restoration
 * 3. Handles hash-based navigation for anchor links
 * 
 * Place this component inside BrowserRouter.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  
  // Disable browser scroll restoration on mount
  useEffect(() => {
    disableScrollRestoration();
  }, []);
  
  // Handle route changes
  useEffect(() => {
    // If there's a hash, let handleHashNavigation deal with it
    if (hash) {
      handleHashNavigation();
    } else {
      // No hash - scroll to top instantly
      scrollToTop('instant');
    }
  }, [pathname, hash]);
  
  return null;
}
